<p-dropdown
  *ngIf="_frmControl"
  [options]="registries"
  optionLabel="name"
  optionValue="id"
  styleClass="w-full"
  [formControl]="_frmControl"
  [filter]="true"
  filterBy="name"
  (onFilter)="filterRegistries$.next($event.filter)"
  [emptyMessage]="'Inserire il nome della società'"
  [placeholder]="placeholder"
  [showClear]="true"></p-dropdown>
